import { render, staticRenderFns } from "./embeddedActions.vue?vue&type=template&id=ab989156&scoped=true&"
import script from "./embeddedActions.vue?vue&type=script&lang=ts&"
export * from "./embeddedActions.vue?vue&type=script&lang=ts&"
import style0 from "./embeddedActions.vue?vue&type=style&index=0&id=ab989156&scoped=true&lang=css&"
import style1 from "./embeddedActions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab989156",
  null
  
)

export default component.exports